.resize-handle {
  position: absolute;
  width: 16px;
  height: 16px;
  top: -2px;
  right: -2px;
  cursor: nesw-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  touch-action: none;
  user-select: none;
}

.resize-handle--dragging {
  cursor: nesw-resize;
}
